import InputMask from '~/components/common/InputMask'
import ErrorPage from '~/pages/_error'
import Announcement from '~/components/common/Announcement'
import useGlobalError from '~/hooks/useGlobalError'
import useAnnouncements from '~/hooks/useAnnouncements'
import useDevice from '~/hooks/useDevice'
import useInternetConnection from '~/hooks/useInternetConnection'
import React, {useEffect, useMemo} from 'react'
import ShardIframe from './ShardIframe'
import { useAnalytics } from "~/hooks/useAnalytics";
import { useFeatureFlags } from "~/hooks/useFeatureFlags";
import { useDatadog } from "~/utils/datadog";
import { SignedIn, SignedOut } from "@clerk/nextjs";
import {AuthIntermediator} from "~/components/AuthIntermediator";

const Renderer = (props) => {
  useDevice()
  useInternetConnection()
  useAnalytics()
  useFeatureFlags()
  useDatadog()

  const { Component, pageProps } = props
  const [error] = useGlobalError(props.error || props.err)
  const { announcements } = useAnnouncements()
  const errorAnnouncement = useMemo(() => {
    return announcements.find(a => !a.modal)
  }, [announcements])

  const modalAnnouncements = useMemo(() => {
    return announcements.filter(a => a.modal)
  }, [announcements])

  useEffect(() => {
    if(window.originalPostMessage) {
      console.warn("Windows Store App")
    }
  }, []);

  return (
    <div className='THEME'>
      {(error || errorAnnouncement) ? (
        <ErrorPage
          err={error}
          statusCode={props.statusCode}
          {...(errorAnnouncement || {})}
        />
      ) : (
        <>
          <SignedIn>
            <AuthIntermediator >
            <Component {...pageProps} />
            <ShardIframe />
            </AuthIntermediator>
          </SignedIn>
          <SignedOut>
            <Component {...pageProps} />
          </SignedOut>
          {!props.statusCode && (
            modalAnnouncements.map((announcement) => (
              <Announcement
                key={announcement.id}
                {...announcement}
              />
            ))
          )}
        </>
      )}
      <InputMask />
    </div>
  )
}

export default Renderer
